/**
 * DTO para propuestas generadas
 */
export class ProposalDto {
    constructor(
        id = null,
        clientName = "",
        clientCompany = "",
        projectName = "",
        transcription = "",
        sections = [],
        pricing = null,
        htmlContent = "",
        status = "DRAFT",
        createdAt = new Date(),
        updatedAt = new Date()
    ) {
        this.id = id;
        this.clientName = clientName;
        this.clientCompany = clientCompany;
        this.projectName = projectName;
        this.transcription = transcription;
        this.sections = sections;
        this.pricing = pricing;
        this.htmlContent = htmlContent;
        this.status = status;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}

/**
 * DTO para secciones de propuesta
 */
export class SectionDto {
    constructor(
        id = null,
        type = "",
        title = "",
        contentMarkdown = "",
        contentHtml = "",
        order = 0
    ) {
        this.id = id;
        this.type = type;
        this.title = title;
        this.contentMarkdown = contentMarkdown;
        this.contentHtml = contentHtml;
        this.order = order;
    }
}

/**
 * DTO para precios de propuesta
 */
export class PricingDto {
    constructor(
        currency = "USD",
        hourlyRate = 0,
        estimatedHours = 0,
        subtotal = 0,
        taxPercentage = 0,
        taxAmount = 0,
        total = 0,
        paymentTerms = []
    ) {
        this.currency = currency;
        this.hourlyRate = hourlyRate;
        this.estimatedHours = estimatedHours;
        this.subtotal = subtotal;
        this.taxPercentage = taxPercentage;
        this.taxAmount = taxAmount;
        this.total = total;
        this.paymentTerms = paymentTerms;
    }
}

/**
 * DTO para datos de cada paso del multistep
 */
export class StepDataDto {
    // Paso 1: Datos iniciales
    static step1 = {
        clientName: "",
        clientCompany: "",
        country: "Costa Rica",
        // "pyme" (desarrollo acelerado, precio/plazo acotado) o "empresarial" (default histórico)
        projectType: "empresarial",
        transcription: "",
        customPrompt: "",
        fullProposalPreview: "",
        fullProposalGenerated: false,
    };

    // Paso 2: Portada
    static step2 = {
        coverTitle: "",
        coverSubtitle: "",
    };

    // Paso 3: Introducción
    static step3 = {
        welcomeMessage: "",
        introduction: "",
    };

    // Paso 4: Socios de Negocios
    static step4 = {
        businessPartners: "",
    };

    // Paso 5: Contexto
    static step5 = {
        projectContext: "",
    };

    // Paso 6: Objetivo General
    static step6 = {
        generalObjective: "",
    };

    // Paso 7: Objetivos Específicos
    static step7 = {
        specificObjectives: [],
    };

    // Paso 8: Alcance
    static step8 = {
        scope: "",
    };

    // Paso 9: Arquitectura y Tecnologías (fusionado)
    static step9 = {
        technologies: [],
        architecture: "",
        mainFlowDiagram: "",
        architectureDiagram: "",
    };

    // Paso 10: Propuesta para la solución
    static step10 = {
        proposedSolution: "",
    };

    // Paso 11: Equipo asignado
    static step11 = {
        teamMembers: [],
    };

    // Paso 12: Cronograma
    static step12 = {
        timeline: "",
        ganttChart: "",
    };

    // Paso 13: Inversión
    static step13 = {
        pricing: new PricingDto(),
        phases: [],
        licenses: [],
        extraTables: [],
        paymentPlans: [],
        warranties: "",
        validityPeriod: 30,
        additionalNotes: "",
        quotationNumber: "",
    };

}

/**
 * Tipos de secciones disponibles
 */
export const SECTION_TYPES = {
    COVER: "cover",
    INTRODUCTION: "introduction",
    BUSINESS_PARTNER: "business_partner",
    CONTEXT: "context",
    GENERAL_OBJECTIVE: "general_objective",
    SPECIFIC_OBJECTIVES: "specific_objectives",
    SCOPE: "scope",
    TECHNOLOGIES: "technologies",
    ARCHITECTURE: "architecture",
    TIMELINE: "timeline",
    INVESTMENT: "investment",
    PAYMENT_TERMS: "payment_terms",
};

/**
 * Estados de propuesta
 */
export const PROPOSAL_STATUS = {
    DRAFT: "DRAFT",
    GENERATED: "GENERATED",
    SENT: "SENT",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
};
